import React from "react";

/**
 * Animated water shimmer overlay.
 * Uses SVG feTurbulence + feDisplacementMap for a caustic-like effect,
 * animated with SMIL for a slow, breathing water surface.
 */
export const WaterShimmer = ({ className = "", opacity = 0.35 }) => {
  return (
    <svg
      className={`absolute inset-0 w-full h-full pointer-events-none ${className}`}
      style={{ mixBlendMode: "screen", opacity }}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <filter id="amme-water" x="0" y="0" width="100%" height="100%">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.012 0.028"
            numOctaves="2"
            seed="7"
            result="turb"
          >
            <animate
              attributeName="baseFrequency"
              dur="24s"
              values="0.012 0.028; 0.018 0.020; 0.010 0.032; 0.012 0.028"
              repeatCount="indefinite"
            />
          </feTurbulence>
          <feColorMatrix
            in="turb"
            type="matrix"
            values="0 0 0 0 0.72
                    0 0 0 0 0.78
                    0 0 0 0 0.70
                    0 0 0 1 0"
            result="tinted"
          />
          <feGaussianBlur in="tinted" stdDeviation="1.5" />
        </filter>
      </defs>
      <rect width="100%" height="100%" filter="url(#amme-water)" />
    </svg>
  );
};

/**
 * Slow, layered rippling wave lines — decorative divider or accent.
 */
export const WaterWaves = ({ className = "" }) => {
  return (
    <div
      className={`absolute inset-x-0 pointer-events-none overflow-hidden ${className}`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        className="w-full h-full"
      >
        <path
          d="M0,60 C240,20 480,100 720,60 C960,20 1200,100 1440,60 L1440,120 L0,120 Z"
          fill="rgba(61,61,59,0.08)"
        >
          <animate
            attributeName="d"
            dur="14s"
            repeatCount="indefinite"
            values="
              M0,60 C240,20 480,100 720,60 C960,20 1200,100 1440,60 L1440,120 L0,120 Z;
              M0,60 C240,100 480,20 720,60 C960,100 1200,20 1440,60 L1440,120 L0,120 Z;
              M0,60 C240,20 480,100 720,60 C960,20 1200,100 1440,60 L1440,120 L0,120 Z"
          />
        </path>
        <path
          d="M0,70 C240,40 480,110 720,70 C960,40 1200,110 1440,70 L1440,120 L0,120 Z"
          fill="rgba(61,61,59,0.05)"
        >
          <animate
            attributeName="d"
            dur="18s"
            repeatCount="indefinite"
            values="
              M0,70 C240,40 480,110 720,70 C960,40 1200,110 1440,70 L1440,120 L0,120 Z;
              M0,70 C240,110 480,40 720,70 C960,110 1200,40 1440,70 L1440,120 L0,120 Z;
              M0,70 C240,40 480,110 720,70 C960,40 1200,110 1440,70 L1440,120 L0,120 Z"
          />
        </path>
      </svg>
    </div>
  );
};
